export const getEnvVariable = {
  execute(key: string): string {
    return process.env[key] ?? "";
  },
};
